var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBacktopmenuArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.414,
    height: 9,
    viewBox: "0 0 9.414 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#E10092;stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.793 -7)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18,15.5v-8",
    transform: "translate(-6.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.5,11.5l4-4,4,4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBacktopmenuArrow);
export default __webpack_public_path__ + "static/media/backtopmenu-arrow.95013b93368a50f50084727a8b3feaf8.svg";
export { ForwardRef as ReactComponent };